/*
Copyright (C) 2019  Cloudbase Solutions SRL
This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program.  If not, see <http://www.gnu.org/licenses/>.
*/

import React from "react";
import styled from "styled-components";

import { ThemePalette, ThemeProps } from "@src/components/Theme";
import Button from "@src/components/ui/Button";
import Modal from "@src/components/ui/Modal";

import packageJson from "../../../../package.json";

const { version } = packageJson;

/*
 * Swift is built on the open-source Coriolis web UI (AGPL-3.0). The legal line below is the
 * "Appropriate Legal Notices" and the section 13 source offer the AGPL requires; keep it.
 */
export const ABOUT_LEGAL_NOTICE =
  "SwiftIQ includes open-source software, including Coriolis © Cloudbase Solutions SRL, licensed under the GNU Affero General Public License v3. Source code is available on request from Tech9IQ.";

const Wrapper = styled.div<any>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 32px 32px 32px;
  position: relative;
  height: 100%;
  min-height: 0;
`;
const Content = styled.div<any>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  text-align: center;
`;
const Title = styled.div`
  font-size: 32px;
  font-weight: ${ThemeProps.fontWeights.medium};
  color: ${ThemePalette.black};
`;
const Byline = styled.span`
  font-size: 18px;
  font-weight: ${ThemeProps.fontWeights.regular};
  color: ${ThemePalette.grayscale[4]};
`;
const Version = styled.div`
  margin-top: 16px;
  color: ${ThemePalette.grayscale[5]};
  font-size: 14px;
`;
const Legal = styled.div`
  margin-top: 32px;
  max-width: 440px;
  color: ${ThemePalette.grayscale[5]};
  font-size: 12px;
  line-height: 18px;
`;
const Buttons = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 48px;
`;

type Props = {
  onRequestClose: () => void;
};

class AboutModal extends React.Component<Props> {
  render() {
    return (
      <Modal
        title="About SwiftIQ"
        isOpen
        onRequestClose={() => {
          this.props.onRequestClose();
        }}
      >
        <Wrapper>
          <Content>
            <Title>
              SwiftIQ <Byline>by Tech9IQ</Byline>
            </Title>
            <Version>Version {version}</Version>
            <Legal>{ABOUT_LEGAL_NOTICE}</Legal>
          </Content>
          <Buttons>
            <Button
              secondary
              large
              onClick={() => {
                this.props.onRequestClose();
              }}
            >
              Close
            </Button>
          </Buttons>
        </Wrapper>
      </Modal>
    );
  }
}

export default AboutModal;
